import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { PreSignService } from '../../../shared/services/preSign.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { UserService } from '../../../shared/services/user.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { CaseService } from '../../../shared/services/case.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Role } from '../../../shared/models/role';
import { ConfirmationDialogComponent } from '../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { CheckrService } from '../../../shared/services/checkr.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-assign-guardian-dialog',
  templateUrl: './assign-guardian-dialog.component.html',
  styleUrls: ['./assign-guardian-dialog.component.scss'],
  providers: [
    LocalUserService,
    PreSignService
  ]
})
export class AssignGuardianDialogComponent implements OnInit {
  public case: string;
  public org: string;

  // component variables
  caseData: any = null;
  userData: any;

  caseContacts = []
  token: string;
  caseDocuments: any;
  userID: string;
  dateToday = new Date();
  userRole: string;
  uploadLoading: boolean;
  acceptanceData: any
  commentForm: FormGroup;

  // this is a array of blocked dates
  hearingBlockedDates = [0, 5, 6];
  loadingDeny = false;
  mailBlockedDates = [0, 6];
  guardianForm: FormGroup;
  dialogRef: any;
  guardianFormMessage: string = null;
  allowSecondGuardian = false;

  loading: boolean
  error = [];
  guardianList: any;
  screeningList = [];
  selectedScreens = [];
  dropdownSettings = {};
  screenPackage = new FormControl();
  packages = [];
  guardianEmail:any;
  guardianDetail:any;
  caseForm = {
    caseNumber: null,
    guardianAdLitemId: null,
    coGuardianAdLitemId: null,
    message: [],
    email: null
  };

  firstUser: boolean;
  secondUser: boolean;
  constructor(public thisDialog: MatDialogRef<AssignGuardianDialogComponent>,
    public dialog: MatDialog,
    private caseService: CaseService,
    private cognito: CognitoUtil,
    private userService: UserService,
    private checkrService: CheckrService,

    private localUser: LocalUserService,
    private preSign: PreSignService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.commentForm = new FormGroup({
      comment: new FormControl('')
    });

    this.guardianForm = new FormGroup({
      guardianOne: new FormControl(''),
      guardianOneFirstName: new FormControl(''),
      guardianOneLastName: new FormControl(''),
      guardianFromCase: new FormControl(''),
      exsistingGuardian: new FormControl(''),
      guardianTwo: new FormControl(''),
      guardianTwoFirstName: new FormControl(''),
      guardianTwoLastName: new FormControl(''),
      guardianBool: new FormControl(false),
      guardianCoBool: new FormControl(false),
      bond: new FormControl(false),
      bondAmount: new FormControl('', Validators.required),
      firstGuardianMode: new FormControl('TEXT'),
      secondGuardianMode: new FormControl(''),
      changePackage: new FormControl(false),
      selectPackage: new FormControl(''),
      guardianOneAddress: new FormControl(''),
      guardianOnePhoneNo: new FormControl(''),
      guardianTwoAddress: new FormControl(''),
      guardianTwoPhoneNo: new FormControl(''),
    });

    this.caseData = this.data.case;
    this.org = this.data.org;

    this.userID = this.localUser.getUserId();
    this.userRole = this.localUser.getRole();

    this.getContactDetails();
    this.acceptance();
    this.getGuardianList();
    this.getAllPackages();
    this.screeningList
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select Background Check',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 3
    };
  }
  // getCaseData() {
  //   this.loading == true
  //   this.caseService.getCaseById(this.org, this.case)
  //     .subscribe(result => {
  //       this.caseData = result;
  //       this.loading = false
  //       this.getContactDetails();
  //       this.acceptance();
  //       this.getGuardianList();
  //     });
  // }
  validateEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  getContactDetails() {
    let userIds = []

    this.caseData.contacts.forEach(contact => {
      if (contact.user_id!=null &&  !userIds.includes(contact.user_id)){
        userIds.push(contact.user_id)
      }
        
    })
    this.userService.getMultipleUserDetails(userIds).subscribe(data => {
      this.userData = data
      this.fillContacts()
    })
  }
  fillContacts() {

    this.caseContacts = [];

    for (let i = 0; i < this.userData.length; i++) {

      let contact = {
        id: this.userData[i].id,
        name: this.userData[i].name,
        position: '',
        email: this.userData[i].email
      };

      if (this.userData[i].relationship == null) {
        contact.position = this.userData[i].role;
      } else {
        contact.position = this.userData[i].relationship;
      }

      this.caseContacts.push(contact);

      //if(this.userData[i].role =='GUARDIAN'){
        //this.guardianDetail = this.userData[i];
        this.guardianDetail = this.caseData.guardian;
        this.guardianForm.controls.guardianOne.setValue(this.guardianDetail.email);
        this.guardianForm.controls.guardianOneFirstName.setValue(this.guardianDetail.first_name);
        this.guardianForm.controls.guardianOneLastName.setValue(this.guardianDetail.last_name);
        this.guardianForm.controls.guardianOnePhoneNo.setValue(this.guardianDetail.phone_number);
        this.guardianForm.controls.guardianOneAddress.setValue(this.guardianDetail.address);
      //}
    }

  }
  getGuardianList() {

    //this.guardianEmail = this.caseData.summary.guardian_id;
    let email = this.caseData.summary.guardian_id;
    this.loading = true
    this.userService.getUsersByRole(this.org, Role.GUARDIAN)
      .subscribe(list => {
        this.guardianList = list;
        this.loading = false;
      })
  }
  acceptance() {

    if (this.caseData.acceptance === undefined || this.caseData.acceptance == null) {
      return;
    }

    if (this.caseData.acceptance.fiduciary_id === 'fiduciaryId') {
      return;
    }

    let fiduciaryEmail = null;
    let coFiduciaryEmail = null;
    let fiduciaryResult = this.caseData.acceptance.acceptance;
    let coFiduciaryResult = this.caseData.acceptance.cofiduciary_acceptance;

    for (let i = 0; i < this.caseData.contacts.length; i++) {
      if (fiduciaryEmail !== null) {
        if (this.caseData.acceptance.cofiduciary_id === null) {
          break;
        }
      }

      if (this.caseData.contacts[i].user_id === this.caseData.acceptance.fiduciary_id) {
        fiduciaryEmail = this.caseData.contacts[i].email;
      }

      if (this.caseData.contacts[i].user_id === this.caseData.acceptance.cofiduciary_id) {
        coFiduciaryEmail = this.caseData.contacts[i].email;
      }

    }

    this.acceptanceData = {
      fiduciaryEmail: fiduciaryEmail,
      coFiduciaryEmail: coFiduciaryEmail,
      fiduciaryResult: fiduciaryResult,
      coFiduciaryResult: coFiduciaryResult
    };

  }

  getAllPackages() {
    this.checkrService.getcheckrPackages().subscribe(result => {
      this.packages = result.data;
    },error =>{
      this.packages = this.checkrService.getAllPackages();
    });
  }

  guardianSubmit() {

    this.loading = true;
    this.error = [];

    if (!this.validateEmail(this.guardianForm.controls.guardianOne.value)) {
      this.error.push('Fiduciary email invalid');
    }

    if (this.guardianForm.controls.guardianCoBool.value) {
      if (!this.validateEmail(this.guardianForm.controls.guardianTwo.value)) {
        this.error.push('Co-Fiduciary email invalid.')
      }
    }

    if (this.guardianForm.controls.bondAmount.value === '') {
      this.error.push('Bond Amount must be filled in.')
    }

    if (this.error.length !== 0) {
      this.loading = false;
      return;
    }

    let guardianOneMode = this.guardianForm.controls.firstGuardianMode.value; 
    let guardianOneUser,guardianTwoUser;

    let acceptData = {
      'acceptance': null,
      'cofiduciary_acceptance': null,
      'undersigned': 'ADMINISTRATOR',
      'other_text': null
    };
    
    if(guardianOneMode=='DROP'){
      guardianOneUser = this.getUser(this.guardianForm.controls.guardianOne.value,'CONTACT');
      acceptData['fiduciary_id'] =guardianOneUser.id;
      this.firstUser = true;
      this.checkUserStatus(acceptData);
    }else if(guardianOneMode=='LIST'){      
      guardianOneUser = this.getUser(this.guardianForm.controls.guardianOne.value,'GUARDIANS');
      acceptData['fiduciary_id'] =guardianOneUser.id;
      this.firstUser = true;
      this.checkUserStatus(acceptData);
    }else{
      guardianOneUser = {
        email: this.guardianForm.controls.guardianOne.value,
        role: 'GUARDIAN',
        first_name: this.guardianForm.controls.guardianOneFirstName.value,
        last_name: this.guardianForm.controls.guardianOneLastName.value,
        phone_number: this.guardianForm.controls.guardianOnePhoneNo.value,
        address: this.guardianForm.controls.guardianOneAddress.value,
        background_package: this.guardianForm.controls.selectPackage.value,
        background_status : 'new'
      };
      this.userService.postUserInOrg(guardianOneUser, this.org)
      .subscribe(firstGuard => {
        acceptData['fiduciary_id'] =firstGuard.id; 
        this.firstUser = true;
        this.checkUserStatus(acceptData);
      });
    }


    if (!this.guardianForm.controls.guardianCoBool) {
      let guardianTwoMode = this.guardianForm.controls.secondGuardianMode.value;
      if(guardianTwoMode=='DROP'){
        guardianTwoUser = this.getUser(this.guardianForm.controls.guardianOne.value,'CONTACT');
        acceptData['cofiduciary_id'] =guardianTwoUser.id;
        this.secondUser=true;
      }else if(guardianTwoMode=='LIST'){
        guardianTwoUser = this.getUser(this.guardianForm.controls.guardianOne.value,'GUARDIANS');
        acceptData['cofiduciary_id'] =guardianTwoUser.id;
        this.secondUser=true;
      }else{
        guardianTwoUser = {
          email: this.guardianForm.controls.guardianTwo.value,
          role: 'GUARDIAN',
          first_name: this.guardianForm.controls.guardianTwoFirstName.value,
          last_name: this.guardianForm.controls.guardianTwoLastName.value,
          phone_number: this.guardianForm.controls.guardianTwoPhoneNo.value,
          address: this.guardianForm.controls.guardianTwoAddress.value,
          background_package: this.guardianForm.controls.selectPackage.value,
          background_status : 'new'
        };

        this.userService.postUserInOrg(guardianTwoUser, this.org)
          .subscribe(secondGuard => {
            acceptData['cofiduciary_id'] =secondGuard.id;
            this.secondUser=true;
            
          });
      }
     }else{
       this.secondUser=true;
     }
     
     this.checkUserStatus(acceptData);
  }
  
  checkUserStatus(acceptData){

    if(this.firstUser && this.secondUser){
      this.postAcceptance(acceptData);
    }
  }

  postAcceptance(acceptData) {
    setTimeout(()=>{  
      this.caseService.postGuardians(this.caseData.id, acceptData).subscribe(result => {
        this.confirmGuardianSubmit();
      }, error => {
        this.loading = false;
        var e = 'Server Not Responding';
        this.snackBar.open(e, '', {
          duration: 2000,
        });
      });
    }, 10000);
   
  }

  getUser(email, type){

    let user;
    if(type =='CONTACT'){
     this.caseContacts.forEach(contact =>{
       if(contact.email == email){
         user = contact;
       }
      });
    }else{
      this.guardianList.forEach(guardian =>{
        if(guardian.email == email){
          user = guardian;
        }
       });
    }
    return user;
  }

  
  confirmGuardianSubmit() {

    let data = {
      status:"UPLOAD_JUDGE_SIGNED",
      bond: this.guardianForm.controls.bondAmount.value.toString(),
      isBondSubmitted:this.guardianForm.controls.bond.value
    };

    this.caseService.putCaseNew(this.org, this.caseData.id, data)
      .subscribe(result => {
        this.thisDialog.close(true);
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/assign-guardian-dialog/assign-guardian-dialog.component.ts